import { Helmet } from '@dr.pogodin/react-helmet';

const SITE_URL = 'https://www.destockpro.be';
const SITE_NAME = 'DestockPro';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

export default function SEO({ title, description, path = '', image, type = 'website', schema, noindex = false, robots }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Marketplace du déstockage professionnel`;
  const fullUrl = `${SITE_URL}${path}`;
  const fullImage = image || DEFAULT_IMAGE;
  const metaDescription = description || "Achetez et vendez du matériel professionnel de déstockage entre entreprises en Belgique, France, Luxembourg et Pays-Bas. Piscine, HVAC, construction, plomberie et plus.";
  const robotsContent = robots || (noindex ? 'noindex, nofollow' : null);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={fullUrl} />
      {robotsContent && <meta name="robots" content={robotsContent} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_BE" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
